// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/9f563846b718399fbe6d.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"f0b62604bc9195ce0aa1","171":"f665edd0e0177ea43483","172":"f68cce00f9e1886dedd1"}[chunkId] + ".chunk.js";
};